module.exports = __webpack_public_path__ + "8.jpg?8b024090d7114e469a2eb0aad4e79727";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resources/img/8.jpg
// module id = 63
// module chunks = 0